import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { DettaglioErroreDTO } from "../dto/dettaglio-erroreDTO";
import { MessaggioErroreDTO } from "../dto/messaggio-erroreDTO";
import { DettaglioErroreVO } from "../vo/dettaglio-erroreVO";
import { MessaggioErroreVO } from "../vo/messaggio-erroreVO";

@Injectable({
  providedIn: "root",
})
export class MapperMessaggioErrore
  implements MapperInterface<MessaggioErroreDTO, MessaggioErroreVO> {
  constructor() {}
  convertVoToDto(vo: MessaggioErroreVO): MessaggioErroreDTO {
    if (vo != null) {
      const dto = new MessaggioErroreDTO();
      // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
      dto.messaggio = vo.messaggio;
      dto.warning = vo.warning;

      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: MessaggioErroreDTO): MessaggioErroreVO {
    if (dto != null) {
      const vo = new MessaggioErroreVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      vo.warning = dto.warning;
      vo.messaggio = dto.messaggio;
      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(voList: MessaggioErroreVO[]): MessaggioErroreDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(dtoList: MessaggioErroreDTO[]): MessaggioErroreVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
